import { Components, Theme } from '@mui/material/styles';
import scssVariables from '@styles/variables.module.scss';

export const MuiLink: Components<Theme>['MuiLink'] = {
  defaultProps: {
    underline: 'hover',
  },
  styleOverrides: {
    root: {
      color: scssVariables.ColorFog100,

      '&:hover': {
        color: scssVariables.ColorFog80,
      },
    },
  },
};
